import { render, staticRenderFns } from "./DNSBindingShow.vue?vue&type=template&id=501dabe8&"
import script from "./DNSBindingShow.vue?vue&type=script&lang=js&"
export * from "./DNSBindingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports